import styled from "styled-components";

interface propsTitle {
  margin?: any;
}

interface PropsRatingNPS {
  color?: any;
}

export const DivStyled = styled.div`
  padding: 20px;
  background-color: #f0f0f5;
  border-radius: 8px;
  margin: 15px 0px;
`;

export const Text = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #3D3D4C;
  margin-bottom: ${(props: propsTitle) => `${props.margin ? props.margin : `5px`}`};
`;


export const ViewNumberNPS = styled.div`
  border-radius: 4px;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  margin-vertical: 8px;
  margin-horizontal: 3.1px;

  display:inline;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  padding: 4px;
  background-color: ${(props: PropsRatingNPS) =>`${props.color}`};
  margin-left: 5px;
`;

export const TextNPS = styled.div`
font-size: 16px;
font-weight: 600;
color: ${(props: PropsRatingNPS) =>`${props.color}`};
margin-bottom: 5px;
display:inline;

border-radius: 4px;
width: 22px;
height: 22px;
margin-vertical: 8px;
margin-horizontal: 3.1px;
`;
